import { useMsal } from '@azure/msal-react';
import { InteractionStatus } from '@azure/msal-browser';
import LoginModal from './LoginModal';

function ProtectedRoute({ children }) {
  const { accounts, inProgress } = useMsal();

  const isAuthenticated = accounts.length > 0;
  const isBusy =
    inProgress === InteractionStatus.HandleRedirect ||
    inProgress === InteractionStatus.Login ||
    inProgress === InteractionStatus.Startup;

  // Still processing the redirect — render nothing until MSAL is ready
  if (isBusy) return null;

  // Not authenticated and not busy — show login
  if (!isAuthenticated) return <LoginModal />;

  // Authenticated — render the app
  return children;
}

export default ProtectedRoute;